






import {Component} from 'vue-property-decorator'
import Posts from '@/components/admin/Posts.vue'
import PageBase, {BreadCrumb} from '@/pages/page-base'

@Component({
  components: {
    Posts
  }
})
export default class StaffBlogIndex extends PageBase {
  mounted(): void {
    super.mounted()
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: 'スタッフブログ一覧'
      }
    ]
  }
}
